buyInStoreLib = {
    checkBuyInStore: function (element) {
        var url=$(element).attr('seo-data-url');
        if(typeof url !== typeof undefined && url !== false){
            $.ajax({
                url: $(element).attr('seo-data-url') + "/ajax", async: false
            }).done(function (data) {
                console.log(data.message);
                if (data.reponseCode == 'redirect') {
                    buyInStoreLib.buyInStoreRedirect(data.redirectUrl);
                } else if (data.reponseCode == 'open-popin') {
                    buyInStoreLib.displayBuyInStore(element);
                }
            });
        }
        else{
            window.location.href=$(element).attr('href');
        }
    },
    buyInStoreRedirect: function (url) {
        var a = $("#buyinstore-redirect-link");
        a.attr("href", url);
        // check external url
        var hostRegEx = new RegExp(location.host);
        var absoluteUrlRegEx = new RegExp('^(?:[a-z]+:)?//', 'i');
        if (!absoluteUrlRegEx.test(url)) {
            a[0].click();
        } else {
            a.attr("target", "_blank");
            a[0].click();
        }
    },
    bindBuyInStoreChangeCountry: function () {
        $(".buyinstoreChangeCountry").on("click", function (e) {
            e.preventDefault();
            ACC.product.checkBuyInStore(this);
        });
    },
    displayBuyInStore: function (element) {
        $.ajax({
            url: $(element).attr('seo-data-url') + "/popin/ajax"
        }).done(function (html) {
            $("#ModalConnectorCommerce").addClass("modal-business");
            $("#ModalConnectorCommerce .modal-body").html(html);
            $("#ModalConnectorCommerce").show();
            $("#ModalConnectorCommerce").modal();
            if(GSEB.constants.site=="SEB") {
                $("#ModalConnectorCommerce .modal-header").html($(".buyinstore").html());
            }
            buyInStoreLib.disableScroll();

            ACC.product.countrySelector();
            buyInStoreLib.bindBuyInStoreChangeCountry();
            // Ajout fonction sur l'event hide pour supprimer le contenu de la
            // modal
            $("#ModalConnectorCommerce").on('hidden.bs.modal', function () {
                $("#ModalConnectorCommerce .modal-body").html("");
                $("#ModalConnectorCommerce").removeClass("modal-business");
                buyInStoreLib.enableScroll();
            });
            // bind function for product range on select change
            $('#SelectbusinessRange').change(function (event) {
                if ($('#SelectbusinessRange').val() != '') {
                    $('#StoreStockLocator').show();
                }
            });
        }).fail(function (html) {
            $("#ModalConnectorCommerce .modal-body").html(html.responseText);
            $("#ModalConnectorCommerce").show();
            $("#ModalConnectorCommerce").modal();
            if(GSEB.constants.site=="SEB") {
                $("#ModalConnectorCommerce .modal-header").html($(".buyinstore").html());
            }
            // Ajout fonction sur l'event hide pour supprimer le contenu de la
            // modal
            $("#ModalConnectorCommerce").on('hidden.bs.modal', function () {
                $("#ModalConnectorCommerce .modal-body").html("");
                buyInStoreLib.enableScroll();
            });
        });
    },
    sendRequest: function (lat, lng, element) {
        if (lat != null && lat != undefined && lng != null && lng != undefined) {
            var url = $("#buyInStoreForm").attr('action');
            if ($("#SelectbusinessRange").val() != null) {
                url = $("#SelectbusinessRange").val();
            }
            var limit = element && isMobile ? $(element).val() : (isMobile ? 5 : 0);
            spinnerON("#ModalConnectorCommerce");
            jQuery.ajax({
                type: "GET",
                url: url,
                data: "&lng=" + lng + "&lat=" + lat + "&" + $("#buyInStoreForm").serialize() + '&limit='+limit
            }).done( function (data) {
                $('#MapStoreStok').html(data);
                if(!element) {
                    document.querySelector('#MapStoreStok').scrollIntoView({
                        behavior: 'smooth' ,
                        block: 'start'
                    });
                    if(GSEB.constants.site=='AllClad' || GSEB.constants.site=='lagostina') {
                        centerModals();
                    }
                }
                $('#ModalConnectorCommerce .return-buyonline').unbind('click')
                    .on('click', function (e) {
                        e.preventDefault();
                        $("#ModalConnectorCommerce").modal("hide");
                        $('.product-detail .buyonline').trigger('click');
                    });
            }).always(function(){
                spinnerOFF("#ModalConnectorCommerce");
            }) ;
        }
    },
    getBuyInStoreShops: function () {
        var lat;
        var lng;
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({'address': $('#FieldLocalisation').val()}, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                lat = results[0].geometry.location.lat();
                lng = results[0].geometry.location.lng();
                localStorage.setItem('buyInStoreLat', lat);
                localStorage.setItem('buyInStoreLng', lng);
                buyInStoreLib.sendRequest(lat, lng);
            }
        });
    },
    getBuyInStoreShopsWithLocateMe: function (element) {
        try {
            var gps = navigator.geolocation;
            gps.getCurrentPosition(buyInStoreLib.positionRetrySuccessNearMe, function (error) {
                $('#geoLocationError').show();
                console.log("An error occurred... The error code and message are: " + error.code + "/" + error.message);
            });
        }
        catch (error) {
            console.log("An error occurred... ");
        }
    },
    positionRetrySuccessNearMe: function (position) {
        var lat = position.coords.latitude;
        var lng = position.coords.longitude;
        localStorage.setItem('buyInStoreLat', lat);
        localStorage.setItem('buyInStoreLng', lng);
        buyInStoreLib.sendRequest(lat, lng);
    },
    showMore: function (element){
        buyInStoreLib.sendRequest(localStorage.getItem("buyInStoreLat"), localStorage.getItem("buyInStoreLng"), element);
    },
    disableScroll: function(){
        $('body').css({
            overflow: 'hidden'
        });
    },
    enableScroll: function (){
        $('body').css({
            overflow: 'auto'
        });
    }
};

$(document).on('click', '.buyinstore', function (e) {
    e.preventDefault();
    buyInStoreLib.checkBuyInStore(this);
});